import { render } from "./MatrixMaterialCenter.vue?vue&type=template&id=762356cf&scoped=true"
import script from "./MatrixMaterialCenter.vue?vue&type=script&lang=js"
export * from "./MatrixMaterialCenter.vue?vue&type=script&lang=js"

import "./MatrixMaterialCenter.vue?vue&type=style&index=0&id=762356cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762356cf"]])

export default __exports__